import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { ProgressBar } from "./components";

const Container = styled.div`
  padding: 0px 24px;
  height: 100%;
  display: flex;
  flex-direction: column;
  -webkit-box-align: center;

  justify-content: center;
`;

const SkipButton = styled.button`
  background: transparent;
  border: none;
  color: #2f313b;
  font-size: 16px;
  font-weight: 600;
  width: 30%;
  position: relative;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px;

  &:hover {
    opacity: 0.8;
  }

  span {
    font-size: 12px;
    font-weight: 400;
    color: #6c757d;
  }
`;

// const ProgressBar = styled.div`
//   width: 100%;
//   height: 4px;
//   background-color: #e0e0e0;
//   margin: 8px 0;

//   &::after {
//     content: "";
//     display: block;
//     width: 10%;
//     height: 100%;
//     background-color: #20564b;
//   }
// `;

const Image = styled.img`
  width: 64px;
  height: 64px;
  margin-bottom: 16px;
  margin-top: 30px;
`;

const Greetings = styled.h1`
  color: #2f313b;
  font-family: sans-serif, sans-serif;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: 40px; /* 125% */
  margin: 0;
`;

const Description = styled.p`
  color: #6e6f76;
  font-family: sans-serif, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 150% */
  margin-top: 12px;
  max-width: 480px;
`;

const Card = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  border-radius: 4px;
  border: 1px dashed #000;
  padding: 16px;
  box-sizing: border-box;
  gap: 12px;
  margin-top: 50px;
  margin-bottom: 50px;
`;

export const Value1 = styled.div`
  color: #2f313b;

  /* Text-14px */
  font-family: sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 18.2px;
`;

// Value Text Style (Black, Extra Bold)
export const Value2 = styled.div`
  font-family: sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 800;
  line-height: 24px; /* 171.429% */
  color: #2f313b;
`;
const Label = styled.div`
  font-family: sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 18.2px;
  color: #6e6f76;
  margin-bottom: 4px;
`;

const Value = styled.div`
  font-family: sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 800;
  line-height: 24px;
  color: #05a8aa;
  margin-bottom: 8px;
`;
const BottomButtons = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: auto;
  margin-bottom: 20px;
  gap: 16px; /* Ensures 16px gap */
  box-sizing: border-box;
`;

interface HalfButtonProps {
  secondary?: boolean;
}

const HalfButton = styled.button<HalfButtonProps>`
  width: 50%;
  background: ${(props) => (props.secondary ? "#FFF" : "rgb(51, 51, 51)")};
  color: ${(props) => (props.secondary ? "#2F313B" : "white")};

  padding: 10px 30px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
`;

const NextButton = styled.button`
  background: rgb(51, 51, 51);
  color: white;
  border: none;
  padding: 10px 50px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
`;

const Row = styled.div`
  width: 48%;
  display: flex;
  flex-direction: column;
`;

const FullWidthRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const Greeting = ({ onProceedWithGreeting, onProceedWithDetails }) => {
  const nav = useNavigate();
  const policyDetail = {
    "Plan Name": "HDFC Life Super Saver Plan",
    "Plan Type": "Non ULIP",
    "Plan Amount": "₹4,62,000",
    "Premium Amount": "₹1,04,500",
    Premium: "Annual",
    Coverage: "10 Year",
    "Premium Plan Year": "5 Year",
  };

  const handleProceed = () => {
    onProceedWithDetails();
  };
  const handleCloseDetails = () => {
    nav("/close");
  };
  return (
    <Container>
      <ProgressBar currentStep={4} totalSteps={7} type="dark" />

      <Image src="/src/assets/images/mdi_greeting.svg" alt="Logo" />
      <Greetings>Greetings!</Greetings>
      <Description>
        This is Pre-issuance verification of your insurance proposal to ensure
        you have understood all the policy benefits, terms, and conditions as
        applicable.
      </Description>

      <Card>
        {/* Plan Name in Full Width */}
        <FullWidthRow>
          <span>
            <Label>Policy No:</Label> <Value1>HB327Y48E7</Value1>
          </span>
        </FullWidthRow>

        {/* Plan Type in Full Width */}
        <FullWidthRow>
          <Label>Plan Name</Label>
          <Value2>{policyDetail["Plan Name"]}</Value2>
        </FullWidthRow>

        {/* Remaining fields in two columns */}
        <div style={{ display: "flex", flexWrap: "wrap", width: "100%" }}>
          {Object.entries(policyDetail)
            .filter(([key]) => key !== "Plan Name")
            .map(([key, value], index) => (
              <Row key={index}>
                <Label>{key}</Label>
                <Value>{value}</Value>
              </Row>
            ))}
        </div>
      </Card>

      <BottomButtons>
        <SkipButton onClick={() => handleCloseDetails()}>Disagree</SkipButton>

        <HalfButton onClick={() => handleProceed()}>I Agree</HalfButton>
      </BottomButtons>
    </Container>
  );
};

export default Greeting;
